import React from "react";
import { RMDReportContainer } from "../../../containers";

const RMDReport = (props) => {
  const isMissed = false;
  return <RMDReportContainer {...props} isMissed={isMissed} />;
};

export default RMDReport;
